import { createStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'
import rootReducer from './reducers/event.root'

// this is really cool, if you don't already know how it works, read up on it here:
// https://github.com/reactjs/redux/issues/99#issuecomment-112198579
function promiseMiddleware() {
  return next => action => {
    const { promise, types, ...rest } = action
    if (!promise) {
      return next(action)
    }

    const [REQUEST, SUCCESS, FAILURE] = types
    next({ ...rest, type: REQUEST })
    return promise.then(
      value => next({ ...rest, value, type: SUCCESS }),
      error => {
        next({ ...rest, error, type: FAILURE })
        throw error
      }
    )
  }
}

// TODO: Remove extension in prod mode
const composeEnhancers =
  (typeof window !== 'undefined' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose

export default function configureStore(initialState) {
  return createStore(
    rootReducer,
    initialState,
    composeEnhancers(applyMiddleware(promiseMiddleware, thunk))
  )
}
